<template>
  <div>
    <div style="padding-bottom: 20px">
      <!-- <van-tabs v-model="activeName"
                sticky
                title-active-color="#2A70F2"
                title-inactive-color="#333333"
                color="#2A70F2"
                line-width="24px"
                @click="onClick"> -->
      <!-- <van-tab title="继续教育"
                 name="a"> -->
      <div class="tips">*要求考试的学时必须通过考试才能计入完成学时</div>
      <div class="listBox" @click="handleBoxClick">
        <div class="studyBox" v-for="(item, index) in jxjyList" :key="index">
          <div class="studyHead">
            <div class="head">{{ item.className }}</div>
            <div class="status">
              {{ item.isAdopt == '01' ? '未通过' : item.isAdopt == '02' ? '已通过' : item.isAdopt == '03' ? '学习中' : '暂无状态' }}
            </div>
          </div>
          <div class="kcB">
            <div class="kcImg">
              <img :src="item.classImage" alt="" v-if="item.classImage != '' && item.classImage != ''" />
              <img src="../assets/new/xiaoBg.png" alt="" v-else />
            </div>
            <div class="kcR">
              <div class="kct">年度：{{ item.classYear }}年</div>
              <div class="kct">报名学时：{{ item.orderCredit }}学时</div>
              <div class="kct">完成学时：{{ item.hasCredit }}学时</div>
            </div>
          </div>

          <div class="timeOrBtn">
            <div class="time1"></div>
            <div style="display: flex">
              <!-- <div class="btn3" @click.stop="goCertificate(item)">学时证明</div> -->
              <div class="btn2" v-if="item.isExam == '02'" @click.stop="goExam(item)">参与考试</div>
              <div class="btn" @click.stop="goChapter(item, 1)">立即学习</div>
            </div>
          </div>
        </div>
      </div>
      <van-empty description="暂无课程 ~" v-if="jxjyList.length == 0" />

      <div class="tk" v-if="bmShow">
        <div class="wtkBox">
          <img class="tkBac" src="../assets/images/bgcJu@2x.png" alt="" />

          <div class="wxTtile">温馨提示</div>

          <div class="wx2">{{ bmText }}前往<span style="color: #2d72f3">继续教育专区</span>选课购买。</div>

          <div class="wxBtn" @click="goBm">立即前往报名</div>
        </div>
      </div>
      <!-- </van-tab>
        <van-tab title="职业教育"
                 name="b"> -->
      <!-- <div class="listBox"
               @click="handleBoxClick">
            <div class="studyBox"
                 v-for="item in zypxList"
                 :key="item.classId">
              <div class="studyHead">
                <div class="head">{{ item.className }}</div>
              </div>
              <div class="kcB">
                <div class="kcImg">
                  <img :src="item.classImage"
                       alt=""
                       v-if="item.classImage != '' && item.classImage != ''" />
                  <img src="../assets/new/xiaoBg.png"
                       alt=""
                       v-else />
                </div>
                <div class="kcR">
                  <div class="kct">培训方式：{{ item.classType == '01' ? '在线' : item.classType == '02' ? '面授' : '混合' }}</div>
                  <div class="kct"></div>
                  <div class="kct">授课老师：{{ item.teacherRealName }}</div>
                </div>
              </div>

              <div class="timeOrBtn">
                <div class="time1"></div>
                <div style="display: flex">
                  <div class="btn"
                       @click.stop="goChapter(item, 2)">立即学习</div>
                </div>
              </div>
            </div>
          </div>

          <van-empty description="暂无课程 ~"
                     v-if="zypxList.length == 0" />
          <div class="tk"
               v-if="bmShow">
            <div class="wtkBox">
              <img class="tkBac"
                   src="../assets/images/bgcJu@2x.png"
                   alt="" />
              <div class="wxTtile">温馨提示</div>

              <div class="wx2">{{ bmText }}前往<span style="color: #2d72f3">继续教育专区</span>选课购买。</div>

              <div class="wxBtn"
                   @click="goBm">立即前往报名</div>
            </div>
          </div> -->
      <!-- </van-tab> -->
      <!-- </van-tabs> -->
    </div>
    <bottomNav></bottomNav>
  </div>
</template>
<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import bottomNav from './component/tabBar.vue';
import { toJxjyClassList, toZypxCourseList, toAllReadyBuy, ylxAddOrder } from '@/api/myClass';
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {
    bottomNav
  },
  data() {
    // 这里存放数据
    return {
      activeName: 'a',
      jxjyList: [], //继续教育的数组
      emptyFalg: false,
      zypxList: [],
      bmShow: false,
      bmText: ''
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    toAllReadyBuy() {
      toAllReadyBuy().then(res => {
        if (res.data.data.msg == '') {
          this.bmShow = false;
        } else {
          this.bmShow = true;
        }
        this.bmText = res.data.data.msg;
      });
    },
    goBm() {
      this.$router.push({
        path: '/chooseClass',
        query: {
          type: '0702'
        }
      });
    },
    handleBoxClick(event) {
      // 检查点击目标是否在按钮区域内
      const isButtonClicked = event.target.closest('.btn, .btn2, .btn3');
      // 如果点击的不是按钮区域，则执行立即学习
      if (!isButtonClicked) {
        this.goChapter();
      }
    },
    //点击tab
    onClick(name, title) {
      if (name == 'a') {
        toJxjyClassList({ pageNum: 1, pageSize: 100 }).then(res => {
          this.jxjyList = res.data.rows;
        });
      } else {
        toZypxCourseList({ pageNum: 1, pageSize: 100 }).then(res => {
          this.zypxList = res.data.rows;
          console.log(this.zypxList);
        });
      }
    },
    goChapter(item, type) {
      console.log(item, 'kkkllll');
      //整体
      if (item.isClassApply == '02') {
        ylxAddOrder({ orderId: item.orderId }).then(res => {});
        setTimeout(() => {
          this.$router.push({
            path: '/chapter',
            query: {
              classId: item.classId,
              className: item.className,
              orderId: item.orderId,
              type: type
            }
          });
        }, 1000);
      } else {
        this.$router.push({
          path: '/chapter',
          query: {
            classId: item.classId,
            className: item.className,
            orderId: item.orderId,
            type: type,
            isClassApply: item.isClassApply
          }
        });
      }
    },
    goCertificate(item) {
      console.log(item);

      console.log('学时证明');
      this.$router.push({
        path: '/classHour',
        query: { CLASS_ID: item.classId, USER_ID: '' }
      });
    },
    goExam(item) {
      console.log(item.classId);
      this.$router.push({
        path: '/examDetail',
        query: {
          classId: item.classId
        }
      });
      console.log('参与考试');
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    //根据路由得值来显示tab
    this.toAllReadyBuy();
    if (this.$route.query.name) {
      this.activeName = this.$route.query.name;
      if (this.activeName == 'a') {
        this.onClick('a');
      } else {
        this.onClick('b');
      }
    } else {
      this.activeName = 'a';
      this.onClick('a');
    }
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {} // 生命周期 - 挂载之前
};
</script>
<style lang="less" scoped>
/* //@import url(); 引入公共css类 */
.tk {
  padding: 0 15px;
  .wtkBox {
    width: 100%;
    height: 151px;
    position: relative;
    padding: 21px 22px 18px 25px;
    .tkBac {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 151px;
      z-index: -1;
    }
    .closeBox {
      width: 24px;
      height: 24px;
      position: absolute;
      bottom: -30px;
      left: 50%;
      transform: translate(-50%);
      cursor: pointer;
    }

    .wxTtile {
      font-size: 13px;
      color: #333333;
    }
    .wx2 {
      margin-top: 12px;
      font-size: 14px;
      color: #333;
    }
    .wxBtn {
      margin-top: 13px;
      width: 120px;
      height: 40px;
      background: linear-gradient(97deg, #2a70f2 0%, #669cff 100%);
      box-shadow: 0px 3px 4px 0px rgba(21, 85, 202, 0.31);
      border-radius: 20px 20px 20px 20px;
      text-align: center;
      font-size: 12px;
      line-height: 40px;
      color: #fff;
      cursor: pointer;
    }
  }
}
.tips {
  width: 100%;
  height: 38px;
  background: rgba(250, 148, 89, 0.1);
  line-height: 38px;
  text-align: center;
  color: #fa9459;
  font-size: 13px;
}
.listBox {
  margin-top: 10px;
  padding: 0 15px;
  .studyBox {
    width: 100%;
    height: 205px;
    background: #ffffff;
    border-radius: 8px 8px 8px 8px;
    padding: 15px;
    margin-bottom: 10px;
    .studyTitle {
      width: 100%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      color: #333333;
      font-size: 15px;
    }
    .studyHead {
      width: 100%;
      display: flex;
      justify-content: space-between;
      .head {
        width: 240px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        color: #333333;
        font-size: 15px;
        line-height: 26px;
      }
      .status {
        width: 56px;
        height: 26px;
        background: rgba(31, 184, 11, 0.1);
        border-radius: 2px 2px 2px 2px;
        text-align: center;
        line-height: 26px;
        color: #1fb80b;
        font-size: 12px;
      }
    }
    .kcB {
      display: flex;
      margin-top: 12px;
      .kcImg {
        width: 110px;
        height: 88px;
        img {
          width: 100%;
          height: 100%;
          border-radius: 8px 8px 8px 8px;
        }
      }
      .kcR {
        padding-top: 11px;
        margin-left: 12px;
        .kct {
          font-size: 13px;
          color: #333;
          margin-bottom: 6px;
        }
      }
    }

    .timeOrBtn {
      margin-top: 20px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .time {
        color: #999999;
        font-size: 13px;
      }
      .btn {
        width: 76px;
        height: 32px;
        background: linear-gradient(97deg, #2a70f2 0%, #669cff 100%);
        border-radius: 16px 16px 16px 16px;
        text-align: center;
        line-height: 32px;
        color: #fff;
        font-size: 13px;
        margin-left: 12px;
      }
      .btn2 {
        width: 76px;
        height: 32px;
        border-radius: 16px 16px 16px 16px;
        border: 1px solid #2a70f2;
        text-align: center;
        line-height: 32px;
        color: #2a70f2;
        font-size: 13px;
        margin-left: 12px;
      }
      .btn3 {
        text-align: center;
        line-height: 32px;
        color: #666666;
        font-size: 13px;
        margin-left: 12px;
        width: 76px;
        height: 32px;
        border-radius: 16px 16px 16px 16px;
        border: 1px solid #666666;
      }
      .time1 {
        width: 60px;
      }
    }
  }
}
</style>
